import ReactDOM from "react-dom";
import routes from "./funnel/route";

ReactDOM.render(
  routes,
  document.getElementById("ajjas")
);
